import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  mostSpentCustomerExcelSendModal: false,
};

const mostSpentCustomerSlice = createSlice({
  name: "mostSpentCustomer",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});
export const { updateConfig } = mostSpentCustomerSlice.actions;
export default mostSpentCustomerSlice.reducer;
